import axios from "axios";
import { ApiService } from "../../servicios/api.service";
import LocalStorageKeys from "../../data/localStorageKeys";

export class UsuarioComercioApi {
  static endPoint = "usuario-comercio/";

  static get BasePath() {
    return ApiService.api + this.endPoint;
  }

  static get AuthHeader() {
    return "Token " + localStorage.getItem(LocalStorageKeys.token);
  }

  static get Headers() {
    return { Authorization: this.AuthHeader };
  }

  static get Config() {
    return { headers: this.Headers };
  }

  static countWithFilter(filter) {
    return axios.post(this.BasePath + "cantidad/filtro", filter, this.Config);
  }

  static create(data) {
    return axios.post(this.BasePath, data, this.Config);
  }

  static delete(id) {
    return axios.delete(this.BasePath + id, this.Config);
  }

  static getListWithFilter(filter) {
    return axios.post(this.BasePath + "filtro", filter, this.Config);
  }

  static update(data) {
    return axios.patch(this.BasePath, data, this.Config);
  }
}
